import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import Fab from '@material-ui/core/Fab';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const HowTo = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [imageSource, setImageSource] = React.useState(null);
    const [additionalInfo, setAdditionalInfo] = React.useState(['']);

    const handleClick = (event) => setAnchorEl(event.currentTarget);

    const handleClose = () => setAnchorEl(null);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => setOpen(true);

    const handleClickClose = () => setOpen(false);

    const handleInstruction = (id) => {
        switch (id) {
            case 1:
                setImageSource("./assets/images/components/island/particle/instructionGIFs/howtofeed.gif");
                let info = [];
                info.push(`* Please hold and drag the food toward dinosaur.`);
                info.push(`* Please always feed your dinosaur to prevent mood meter decreasing.`);
                info.push(`* By completing recommended learning content will increase dinosaur's mood meter and stage.`);
                info.push(`* Alternatively, feeding your dinosaur will increase dinosaur's mood meter and stage.`);
                setAdditionalInfo(info);
                handleClickOpen();
                break;
            case 2:
                setImageSource("./assets/images/components/island/particle/instructionGIFs/howtoclean.gif");
                info = [];
                info.push(`* Your island will be dirty if your dinosaur's mood meter drop to 0 for 3 consecutive days.`);
                info.push(`* You can find back your dinosaur by cleaning the island.`);
                info.push(`* Once island is cleaned, your dinosaur will be back with sad mood.`);
                setAdditionalInfo(info);
                handleClickOpen();
                break;
            case 3:
                setImageSource("./assets/images/components/island/particle/instructionGIFs/howtoshowmessage.gif");
                info = [];
                info.push(`* Please click on the dinosaur to check important notices and messages that dinosaur want to inform you.`);
                setAdditionalInfo(info);
                handleClickOpen();
                break;
            case 4:
                setImageSource("./assets/images/components/island/particle/instructionGIFs/howtoclaim.gif");
                info = [];
                info.push(`* You can claim dinosaur food from treasure box everyday.`);
                setAdditionalInfo(info);
                handleClickOpen();
                break;
        }
    };

    return (
        <div>
            <Fab
                size="medium"
                color="primary" className="dino_howtoContainer" onClick={handleClick}>
                {
                    <ContactSupportIcon />
                }
            </Fab>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                <MenuItem onClick={() => handleInstruction(1)}>How to feed your dinosaur</MenuItem>
                <MenuItem onClick={() => handleInstruction(2)}>How to clean the island</MenuItem>
                <MenuItem onClick={() => handleInstruction(3)}>How to check messages</MenuItem>
                <MenuItem onClick={() => handleInstruction(4)}>How to obtain the food</MenuItem>
            </Menu>

            <Dialog fullWidth={true} maxWidth={'md'}
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClickClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description">
                <DialogContent>
                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                    >
                        <img src={imageSource} style={{ width: '100%', height: 'auto' }} />
                    </Grid>
                    <Alert icon={false} severity="info" style={{ marginTop: 5 }}>
                        <List>
                            {additionalInfo.map((text, index) => (
                                <ListItem
                                    key={text}>
                                    <ListItemText
                                        primary={text}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Alert>
                </DialogContent>
            </Dialog>

        </div>
    );
}

export { HowTo as default }